var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIOphthalmology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.873 50.248c-12.416 0-23.924-6.202-30.78-16.591l-0.354-0.537 0.354-0.537c6.863-10.389 18.367-16.591 30.78-16.591 12.412 0 23.917 6.203 30.771 16.591l0.355 0.537-0.355 0.532c-6.855 10.393-18.359 16.595-30.771 16.595v0zM32.027 42.351c2.466 0 4.787-0.962 6.534-2.704 1.746-1.745 2.704-4.066 2.704-6.534s-0.959-4.785-2.704-6.534c-1.746-1.745-4.068-2.704-6.534-2.704-2.468 0-4.789 0.959-6.533 2.704-1.741 1.749-2.703 4.066-2.703 6.534 0 5.092 4.14 9.238 9.236 9.238zM59.245 33.121c-4.942-6.853-12.141-11.524-20.232-13.269 4.751 2.507 8.005 7.495 8.005 13.232 0 3.997-1.561 7.757-4.384 10.583-1.136 1.134-2.421 2.051-3.815 2.758 8.171-1.714 15.442-6.399 20.426-13.304zM25.522 46.537c-1.48-0.719-2.85-1.674-4.049-2.87-2.831-2.827-4.389-6.586-4.389-10.583 0-3.996 1.558-7.755 4.389-10.581 1.129-1.128 2.416-2.049 3.806-2.752-8.313 1.65-15.727 6.364-20.784 13.37 5.106 7.073 12.617 11.81 21.026 13.416zM28.823 33.633c1.685 0 3.052-1.365 3.052-3.052s-1.368-3.055-3.052-3.055c-1.687 0-3.053 1.368-3.053 3.055 0.001 1.687 1.366 3.052 3.053 3.052z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOphthalmology);
export default __webpack_public_path__ + "static/media/i-ophthalmology.27163bc4.svg";
export { ForwardRef as ReactComponent };